import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import usePageTitle from '../hooks/usePageTitle';

const Cookies = () => {
  usePageTitle('Cookies');
  return (
    <div className="min-h-screen flex flex-col bg-gray-100 dark:bg-gray-900 text-black dark:text-white">
      <Header />
      <div className="flex-1 container mx-auto py-8 px-4">
        <h1 className="text-2xl font-bold mb-4">Politique Cookies</h1>
        <p className="mb-4">Le site utilise uniquement les cookies strictement nécessaires au fonctionnement du service. Aucune fonctionnalité de tracking marketing ou d'analytics tiers n'est activée par défaut.</p>

        <h2 className="font-semibold mt-4">Types de cookies utilisés</h2>
        
        <h3 className="font-semibold mt-3 text-sm">Cookies strictement nécessaires</h3>
        <p className="mb-2 text-sm">Ces cookies sont essentiels au fonctionnement du site et ne peuvent être désactivés :</p>
        <ul className="list-disc ml-6 mb-2 text-sm">
          <li><strong>Cookie de session :</strong> maintien de votre session utilisateur active</li>
          <li><strong>Token d'authentification :</strong> sécurisation de votre connexion (JWT)</li>
          <li><strong>Cookie CSRF :</strong> protection contre les attaques cross-site</li>
        </ul>

        <h3 className="font-semibold mt-3 text-sm">Stockage local (localStorage)</h3>
        <p className="mb-2 text-sm">Nous utilisons le stockage local de votre navigateur pour :</p>
        <ul className="list-disc ml-6 mb-2 text-sm">
          <li>Préférences d'affichage (langue, thème sombre/clair)</li>
          <li>Paramètres d'interface utilisateur</li>
          <li>Consentement aux cookies</li>
        </ul>

        <h3 className="font-semibold mt-3 text-sm">Absence de cookies tiers</h3>
        <p className="mb-4 text-sm">Nous n'utilisons aucun cookie de suivi publicitaire ou analytique tiers (Google Analytics, Facebook Pixel, etc.). Votre navigation reste privée et n'est pas suivie à des fins marketing.</p>

        <h2 className="font-semibold mt-4">Refuser ou supprimer les cookies</h2>
        <p className="mb-2">Vous pouvez refuser les cookies en configurant votre navigateur. Notez que le refus des cookies nécessaires empêchera l'utilisation correcte du service (ex : impossibilité de se connecter).</p>

        <h2 className="font-semibold mt-4">Durée de conservation</h2>
        <p className="mb-2">Les cookies de session sont supprimés à la fermeture du navigateur. Les préférences utilisateur stockées en localStorage sont conservées jusqu'à leur suppression manuelle ou jusqu'à la suppression du compte.</p>

        <p className="text-sm text-primary/80">Le site affiche une bannière d'information sur les cookies et enregistre votre choix dans le stockage local.</p>
        <p className="mt-6"><Link to="/" className="text-accent underline">Retour à l'accueil</Link></p>
      </div>
      <Footer />
    </div>
  );
};

export default Cookies;
